import dateService from '@/services/util/dateService'
import loggingService from '@/services/util/loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'mediaService'
var path = '/Media/'
var isDebug = false

const mediaParentType = {}
mediaParentType.Autopsy = 1
mediaParentType.Toxicology = 2
mediaParentType.MedicalRecords = 3
mediaParentType.PharmacyRecords = 4
mediaParentType.Case = 5

const mediaType = {}
mediaType.AutopsySummary = 1
mediaType.AutopsyPreliminaryReport = 2
mediaType.AutopsyFinalReport = 3
mediaType.AutopsyAddendum = 4
mediaType.ToxicologyReport = 5
mediaType.MedicalRecords = 6
mediaType.PharmacyRecords = 7
mediaType.CaseLetter = 8
mediaType.CaseSupportingDocument = 9
mediaType.CaseImage = 10
mediaType.AutopsyImage = 11
mediaType.AutopsyOther = 16
mediaType.AutopsyMedicalRecords = 17
mediaType.CaseProperty = 18
mediaType.CaseEvidence = 19
mediaType.CasePropertyOther = 20
mediaType.OralSwab = 21
mediaType.BloodSwab = 22
mediaType.NasalSwab = 23
mediaType.BloodCard = 24
mediaType.Fingerprints = 25
mediaType.DNA = 26
mediaType.SpecimenOther = 27
mediaType.SpecimenAutopsy = 28
mediaType.DonorDocument = 29
mediaType.AutopsyAttendance = 30

const mediaSubtype = {}
mediaSubtype.CaseImageCoroner = 1
mediaSubtype.CaseImageAutopsy = 2
mediaSubtype.CaseImageOutsideAgency = 3
mediaSubtype.CaseImageOther = 4

function listByParent (http, mediaParentTypeId, parentId) {
    loggingService.log(isDebug, serviceName, `listByParent - mediaParentTypeId: ${mediaParentTypeId}, parentId: ${parentId}`)
    var requestUrl = `${path}ListByParent?mediaParentTypeId=${mediaParentTypeId}&parentId=${parentId}`
    return http.get(requestUrl).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDateTimeString(value.createdDate)
        })
        return response
    })
}

function listByParentAndType (http, mediaTypeId, mediaSubtypeId, parentId) {
    loggingService.log(isDebug, serviceName, `listByParent - mediaTypeId: ${mediaTypeId}, mediaSubtypeId: ${mediaSubtypeId}, parentId: ${parentId}`)
    var requestUrl = `${path}ListByParentAndType?mediaTypeId=${mediaTypeId}&parentId=${parentId}`

    // if (mediaSubtypeId) {
    requestUrl = requestUrl + `&mediaSubtypeId=${mediaSubtypeId}`
    // }
    return http.get(requestUrl).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDateTimeString(value.createdDate)
        })
        return response
    })
}

function get (http, mediaId, mediaTypeId, mediaSubtypeId, parentId) {
    loggingService.log(isDebug, serviceName, `get - mediaId: ${mediaId}, mediaTypeId: ${mediaTypeId}, mediaSubtypeId: ${mediaSubtypeId}, parentId: ${parentId}`)
    var requestUrl = `${path}Get?mediaId=${mediaId}&mediaTypeId=${mediaTypeId}&parentId=${parentId}`
    if (mediaSubtypeId) {
        requestUrl = requestUrl + `&mediaSubtypeId=${mediaSubtypeId}`
    }
    return http.get(requestUrl, { responseType: 'arraybuffer' })
}

function getMass (http, mediaList) {
    loggingService.log(isDebug, serviceName, `get - mediaDownloadList: ${mediaList}`)
    var requestUrl = `${path}`
    return http.post(requestUrl + 'GetMass', mediaList, { responseType: 'arraybuffer' })
}

function getMediaCompressed (http, mediaId, parentId) {
    loggingService.log(isDebug, serviceName, `getMediaCompressed - mediaId: ${mediaId}, parentId: ${parentId}`)
    var requestUrl = `${path}GetMediaCompressed?mediaId=${mediaId}&parentId=${parentId}`
    return http.get(requestUrl, { responseType: 'arraybuffer' })
}

function getMediaThumbnail (http, mediaId, parentId) {
    loggingService.log(isDebug, serviceName, `getMediaThumbnail - mediaId: ${mediaId}, parentId: ${parentId}`)
    var requestUrl = `${path}GetMediaThumbnail?mediaId=${mediaId}&parentId=${parentId}`
    return http.get(requestUrl)
}

//This is an axios response object that contains a downloaded file
function fileToDownload (response, filename) {
    var link = document.createElement('a')
    link.href = createBlobUrl(response)
    link.download = filename
    link.click()
}

function createBlobUrl (response) {
    var blob = new Blob([response.data], { type: response.headers['content-type'] })
    return (window.URL || window.webkitURL).createObjectURL(blob)
}

function saveFile (http, mediaTypeId, mediaSubtypeId, parentId, fileToUpload, comment) {
    loggingService.log(isDebug, serviceName, 'saveFile for mediaTypeId: ' + mediaTypeId + ', parentId: ' + parentId)

    var data = new FormData()
    data.append('mediaTypeId', mediaTypeId)
    if (mediaSubtypeId) {
        data.append('mediaSubtypeId', mediaSubtypeId)
    }
    data.append('parentId', parentId)
    data.append('file', fileToUpload)
    data.append('comment', comment)
    console.log(path)
    return http.post(path + 'SaveFile', data).then(function (response) {
        loggingService.log(isDebug, serviceName, 'saveFile.then')
        return response
    })
}

//Remove media by mediaId.  Cannot handle removing shapefiles yet due to dependencies
function removeByMediaId (http, mediaId) {
    loggingService.log(isDebug, serviceName, 'removeByMediaId for : ' + mediaId)
    return http.delete(path + `RemoveByMediaId?mediaId=${mediaId}`)
}

//letter generation
function generateLetterPdf (http, generateLetterPdfDto) {
    loggingService.log(isDebug, serviceName, 'generateLetterPdf')
    return http.post(path + `GenerateLetterPdf`, generateLetterPdfDto, { responseType: 'arraybuffer' })
}

function generateAndSaveLetterPdf (http, generateLetterPdfDto) {
    loggingService.log(isDebug, serviceName, 'generateAndSaveLetterPdf')
    return http.post(path + `GenerateAndSaveLetterPdf`, generateLetterPdfDto, { responseType: 'arraybuffer' })
}

// function getHtmlToPdfFile (http, pdfHtmlFileDto) {
//     loggingService.log(isDebug, serviceName, 'getHtmlToPdfFile')

//     //var data = JSON.stringify(html)

//     //return http.post(path + 'GetHtmlToPdfFile', pdfHtmlFileDto, { headers: { 'Content-Type': 'application/json;charset=UTF-8' }, responseType: 'arraybuffer' })
//     return http.post(path + 'GetHtmlToPdfFile', pdfHtmlFileDto, { responseType: 'arraybuffer' })
// }

//letter generate and save file to server
// function generateLetterPdfSave (http, generateLetterPdfDto) {
//     loggingService.log(isDebug, serviceName, 'generateLetterPdfSave')
//     return http.post(path + 'GenerateLetterPdfSave', generateLetterPdfDto, { responseType: 'arraybuffer' })
// }

export default {
    mediaParentType: mediaParentType,
    mediaType: mediaType,
    mediaSubtype: mediaSubtype,
    get: get,
    listByParent: listByParent,
    listByParentAndType: listByParentAndType,
    fileToDownload: fileToDownload,
    getMass: getMass,
    createBlobUrl: createBlobUrl,
    saveFile: saveFile,
    removeByMediaId: removeByMediaId,
    generateLetterPdf: generateLetterPdf,
    generateAndSaveLetterPdf: generateAndSaveLetterPdf,
    getMediaCompressed: getMediaCompressed,
    getMediaThumbnail: getMediaThumbnail
}
